





























































































































































































































































































































































































































































































































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { VibrixEvent, VibrixEventMailTemplate } from "@/interfaces/vibrixEvent";
import { EventService } from "@/services/eventService";
import { FileService } from "@/services/fileService";
import { DateService } from "@/services/dateService";
import ConfirmDeleteDialog from "../components/customActions/ConfirmDeleteDialog.vue";
import { StudioState } from "@/interfaces/studioState";
import { User } from "@/interfaces/user";
import EventMailTemplatesEditor from "@/components/EventMailTemplatesEditor.vue";
import EventDescriptionEditor from "@/components/EventDescriptionEditor.vue";

@Component({
    components: {
        ConfirmDeleteDialog,
        EventMailTemplatesEditor,
        EventDescriptionEditor,
    },
})
export default class EventDetailCard extends Vue {
    @Prop() event!: VibrixEvent;
    @Prop() editable?: boolean;
    @Prop() token?: string;
    @Prop() deleting?: boolean;
    @Prop() allowSignup?: boolean;
    @Prop() showDescription?: boolean;
    @Prop() showJoinDescription?: boolean;
    @Emit() public eventUpdated(event: VibrixEvent): VibrixEvent {
        return event;
    }

    public editmode: boolean = false;
    public formValid: boolean = false;
    public loading: boolean = false;
    public tab = 0;
    public deleteDialogActive = false;
    public errors = { invitationList: false, blockList: false };
    public eventEmailDialog: boolean = false;

    public eventDescriptionDialog: boolean = false;
    public eventJoinDescriptionDialog: boolean = false;
    public eventIsFullDescriptionDialog: boolean = false;

    public get sliderColor(): string {
        if (this.editEvent) {
            if (this.editEvent.maxParticipants < 100) return "green";
            if (this.editEvent.maxParticipants < 180) return "orange";
            if (this.editEvent.maxParticipants < 250) return "error";
        }
        return "red darken-4";
    }

    public incrementMaxParticipants() {
        if (this.editEvent) {
            this.editEvent.maxParticipants++;
        }
    }

    public get rules() {
        return {
            file: (value: File) =>
                !value ||
                (value.name as string).includes(".csv") ||
                this.$t("studio.manager.csvOnly"),
            required: (v: string) =>
                !!v || (this.$t("studio.required") as string),
        };
    }

    public get registrationLinkRelative() {
        return `/events/registration?eventId=${this.event.id}&email=&s=`;
    }

    public get registrationLink() {
        return `${window.location.protocol}//${window.location.host}${this.registrationLinkRelative}`;
    }

    public get user(): User | null {
        return this.$store.state.user;
    }

    public get studios(): StudioState[] {
        return this.user?.own_studios.map(s => s.studio) ?? [];
    }

    public studioName(studioId: string): string {
        const s: StudioState | null =
            this.studios.find(s => s.studioId == studioId) || null;
        return s?.studioName || "";
    }

    public editEvent: {
        id: string;
        title: string;
        description: string;
        join_description: string;
        is_private: boolean;
        invitationList: { email: string }[];
        blockList: { email: string }[];
        studio_id: string;
        maxParticipants: number;
        isFullDescription: string;
        mailTemplates: VibrixEventMailTemplate;
    } | null = null;

    @Emit()
    public startEdit() {
        this.editEvent = { ...this.event };
        if (this.editEvent.isFullDescription == null) {
            this.editEvent.isFullDescription = "";
        }
        this.editmode = true;
    }

    @Emit()
    public eventReport() {
        return this.event.id;
    }

    @Emit()
    public endEdit() {
        this.editmode = false;
        this.editEvent = null;
    }

    public async submitEdit() {
        this.loading = true;
        try {
            if (!this.editEvent || !this.token) {
                return;
            }
            const event = await EventService.updateEvent(
                this.editEvent,
                this.token
            );
            this.eventUpdated(event);
            this.endEdit();
        } finally {
            this.loading = false;
        }
    }

    public rightToolbar: string = "preview toc sync-scroll";

    public formatIsoString(string: string) {
        return DateService.formatIsoString(string, this.$i18n.locale);
    }

    public async parseCsv(f: File | null): Promise<{ email: string }[]> {
        if (this.token && f) {
            return EventService.parseCsv(f, this.token);
        }
        return [];
    }

    public async updateList(f: File | null, list: "block" | "allow") {
        const res = await this.parseCsv(f);
        if (this.editEvent) {
            switch (list) {
                case "allow": {
                    this.editEvent.invitationList = res;
                    break;
                }
                case "block": {
                    this.editEvent.blockList = res;
                    break;
                }
            }
        }
    }

    @Emit() eventDeleted(confirmation: boolean) {
        this.deleteDialogActive = false;
        if (confirmation) {
            this.endEdit();
            return this.event.id;
        }
    }

    public appendToBlockList(email: string) {
        if (this.editEvent) {
            this.editEvent.blockList = [...this.editEvent.blockList, { email }];
        }
    }

    public removeFromBlockList(email: string) {
        if (this.editEvent) {
            this.editEvent.blockList = [...this.editEvent.blockList].filter(
                e => e.email != email
            );
        }
    }

    public isBlocked(email: string): boolean {
        if (
            this.editEvent &&
            this.editEvent.blockList.findIndex(e => e.email == email) >= 0
        ) {
            return true;
        }
        if (
            !this.editEvent &&
            this.event.blockList.findIndex(e => e.email == email) >= 0
        ) {
            return true;
        }
        return false;
    }

    public copyToClipboard(eventLink: string) {
        navigator.clipboard.writeText(eventLink);
        this.$store.commit("showSnackbar", {
            text: this.$t("event.copyToClipboard"),
            color: "success",
        });
    }

    public handleUploadImage(
        event: Event,
        insertImage: Function,
        files: File[]
    ) {
        FileService.uploadFile("event", files[0]).then(response => {
            insertImage({
                url: `/api/file/by_id/${response.data.id}`,
                desc: response.data.filename,
                width: "300",
                height: "300",
            });
        });
    }

    public toSignup() {
        this.$router.push(this.registrationLink);
    }
}
